import localAssetStore from './localAssetStore'

class AvatarChatMediaUploadService {
  async uploadAvatar({ file, metadata = {} }) {
    const record = await localAssetStore.saveAsset('avatar', file, metadata)
    return {
      ...record,
      url: localAssetStore.getObjectUrl(record)
    }
  }

  async uploadBackground({ file, metadata = {} }) {
    const record = await localAssetStore.saveAsset('background', file, metadata)
    return {
      ...record,
      url: localAssetStore.getObjectUrl(record)
    }
  }

  async uploadLipSyncProfile({ file, metadata = {} }) {
    const record = await localAssetStore.saveAsset('lipsync-profile', file, metadata)
    return {
      ...record,
      url: localAssetStore.getObjectUrl(record)
    }
  }

  async listAvatars() {
    return localAssetStore.listAssets('avatar')
  }

  async listBackgrounds() {
    return localAssetStore.listAssets('background')
  }

  async deleteBackground(id) {
    return localAssetStore.deleteAsset(id)
  }

  async deleteAvatar(id) {
    // Avatars are stored as generic assets; delete by id
    return localAssetStore.deleteAsset(id)
  }

  async listLipSyncProfiles() {
    return localAssetStore.listAssets('lipsync-profile')
  }

  toOption(record) {
    return localAssetStore.toOption(record)
  }
}

export default new AvatarChatMediaUploadService()
